<template>
  <v-container fluid class="d-flex flex-column">
    <span class="muli-semibold paragraph label mb-1">Para</span>
    <div class="d-flex mb-4">
      <span v-if="isCNPJ" class="muli-semibold h3 label mr-1">CNPJ:</span>
      <span v-else class="muli-semibold h3 label mr-1">CPF:</span>
      <span class="muli-bold h3 content">{{
        $api.UI.Format.DocumentoFederal(dadosBancarios.documentoFederal)
      }}</span>
    </div>
    <span class="muli-semibold paragraph label mb-1">Banco</span>
    <span class="muli-bold h3 content">{{ dadosBancarios.bancoDescricao }}</span>
    <div class="d-flex">
      <span class="muli-semibold h3 label mr-1">Agência:</span>
      <span class="muli-bold h3 content">{{ dadosBancarios.agencia }}</span>
    </div>
    <div class="d-flex">
      <span class="muli-semibold h3 label mr-1">Número da conta:</span>
      <span class="muli-bold h3 content">{{ dadosBancarios.conta }}</span>
    </div>
    <div class="d-flex">
      <span class="muli-semibold h3 label mr-1">Tipo de conta:</span>
      <span class="muli-bold h3 content">{{ textoTipoConta }}</span>
    </div>
  </v-container>
</template>

<script>
export default {
  props: {
    dadosBancarios: Object,
  },
  computed: {
    textoTipoConta() {
		
	 const obj = Object.assign({}, this.dadosBancarios)

      switch (obj.tipoConta) {
        case "CC":
          return "Conta corrente";
        case "PP":
          return "Conta poupança";
        case "PG":
          return "Conta de pagamento";
        case "CD":
          return "Conta de depósito";
      }
    },
    isCNPJ() {
	  const obj = Object.assign({}, this.dadosBancarios)

      return obj.documentoFederal.length > 11;
    },
  },
};
</script>

<style scoped>
.label {
  color: #808080;
}

.content {
  color: #1a1a1a;
}
</style>